import JoinUsDetail from './join-us-detail'
export default [
  {
    path: '/joinUsDetail',
    name: 'join-us-detail',
    component: JoinUsDetail
  }
]



// WEBPACK FOOTER //
// ./src/components/join-us-detail/join-us-detail-router.js